__turbopack_context__.v({
  "notice": "notice-module__9ROOMW__notice",
});
